import { useEffect, useReducer } from "react";

import useTrafficSearchApiParams from "../../../hooks/useApiParamsSearch";
import {
    useOrganicKeywordsData,
    usePaidKeywordsData,
    useTrafficData,
} from "../../../services/search-overview-api/apiHooks";
import { ESourceType } from "../../../types";
import { reducer } from "../state/reducer";
import type { TransformedDataTable } from "../types";
import { transformOrganicPaidKeywordsData, transformOrganicPaidTrafficData } from "../utils";

const useOrganicPaidDataTable = () => {
    const { trafficSearchApiParams } = useTrafficSearchApiParams();

    const { data: trafficData, isLoading } = useTrafficData(trafficSearchApiParams);
    const { data: organicKeywordsData, isLoading: isLoadingOrganicKeywords } = useOrganicKeywordsData({
        ...trafficSearchApiParams,
        SourceType: ESourceType.ORGANIC,
    });
    const { data: paidKeywordsData, isLoading: isLoadingPaidKeywords } = usePaidKeywordsData({
        ...trafficSearchApiParams,
        SourceType: ESourceType.PAID,
    });

    const [tableData, dispatch] = useReducer(reducer, {} as TransformedDataTable);

    useEffect(() => {
        if (trafficData) {
            transformOrganicPaidTrafficData(trafficData, dispatch);
        }
    }, [trafficData]);

    useEffect(() => {
        if (organicKeywordsData) {
            transformOrganicPaidKeywordsData(organicKeywordsData, ESourceType.ORGANIC, dispatch);
        }
    }, [organicKeywordsData]);

    useEffect(() => {
        if (paidKeywordsData) {
            transformOrganicPaidKeywordsData(paidKeywordsData, ESourceType.PAID, dispatch);
        }
    }, [paidKeywordsData]);

    return { data: Object.values(tableData), isLoading, isLoadingPaidKeywords, isLoadingOrganicKeywords };
};

export default useOrganicPaidDataTable;
